import { useEffect, useState } from "react";

function colorFor(score) {
  if (score >= 80) return { stroke: "#10b981", glow: "rgba(16,185,129,0.35)", label: "text-emerald-400" };
  if (score >= 50) return { stroke: "#f59e0b", glow: "rgba(245,158,11,0.35)", label: "text-amber-400" };
  return { stroke: "#ef4444", glow: "rgba(239,68,68,0.4)", label: "text-red-400" };
}

export const ScoreGauge = ({ score = 0, grade = "" }) => {
  const [animated, setAnimated] = useState(0);
  const color = colorFor(score);
  const radius = 86;
  const circumference = 2 * Math.PI * radius;
  const progress = circumference - (animated / 100) * circumference;

  useEffect(() => {
    let frame;
    const start = performance.now();
    const duration = 900;
    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setAnimated(Math.round(eased * score));
      if (t < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [score]);

  return (
    <div
      className="relative flex flex-col items-center justify-center rounded-2xl border border-slate-800 bg-slate-900/80 p-6 sm:p-8"
      style={{ boxShadow: `0 10px 60px -20px ${color.glow}` }}
      data-testid="security-score-gauge"
    >
      <div className="relative h-56 w-56">
        <svg className="h-full w-full -rotate-90" viewBox="0 0 200 200">
          <circle
            cx="100"
            cy="100"
            r={radius}
            stroke="rgba(148,163,184,0.12)"
            strokeWidth="14"
            fill="none"
          />
          <circle
            cx="100"
            cy="100"
            r={radius}
            stroke={color.stroke}
            strokeWidth="14"
            strokeLinecap="round"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={progress}
            style={{
              filter: `drop-shadow(0 0 10px ${color.glow})`,
              transition: "stroke 400ms ease",
            }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold">
            Security Score
          </div>
          <div
            className={`font-display text-6xl font-extrabold ${color.label}`}
            data-testid="security-score-value"
          >
            {animated}
          </div>
          <div className="text-xs text-slate-500 font-mono">out of 100</div>
        </div>
      </div>
      <div
        className={`mt-4 text-center text-sm font-semibold ${color.label}`}
        data-testid="security-score-grade"
      >
        {grade}
      </div>
    </div>
  );
};

export default ScoreGauge;
